<template>
  <div id="app">
    <div class="ls-root-wrapper">
      <keep-alive>
        <router-view class="router-view" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view class="router-view" v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <van-tabbar
      class="ls-tabbar"
      placeholder
      v-show="tabShow"
      fixed
      route
      safe-area-inset-bottom
      v-model="active"
      active-color="#5597EC"
      inactive-color="#999999"
    >
      <van-tabbar-item replace to="/home">
        <span style="font-size: 10px" >首页</span>
        <template #icon="props">
          <img :src="props.active ? icon_home.active : icon_home.inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace to="/record">
        <span style="font-size: 10px">阅读记录</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_before.active : icon_before.inactive"
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace to="/scoreShop">
        <span style="font-size: 10px">积分商城</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_scoreshop.active : icon_scoreshop.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace to="/my">
        <span style="font-size: 10px">我的</span>
        <template #icon="props">
          <img :src="props.active ? icon_my.active : icon_my.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import store from "./store";
export default {
  name: "App",
  data() {
    return {
      active: 0,
      icon_home: {
        active: require("./assets/imgs/icon/tab-home-active.png"),
        inactive: require("./assets/imgs/icon/tab-home-inactive.png"),
      },
      icon_before: {
        active: require("./assets/imgs/icon/tab-calendar-active.png"),
        inactive: require("./assets/imgs/icon/tab-calendar-inactive.png"),
      },
      icon_scoreshop: {
        active: require("./assets/imgs/icon/tab-scoreshop-active.png"),
        inactive: require("./assets/imgs/icon/tab-scoreshop-inactive.png"),
      },
      icon_my: {
        active: require("./assets/imgs/icon/tab-my-active.png"),
        inactive: require("./assets/imgs/icon/tab-my-inactive.png"),
      },
    };
  },
  computed: {
    tabShow() {
      return this.$store.state.app.tabShow;
    },
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route.path + new Date();
    },
  },
};
</script>

<style>
@import "./assets/font/font.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  height: 100%;
  color: #2c3e50;
  line-height: 1.5;
  flex-direction: column;
  display: flex;
  background-color: #fcfcfc;
  overflow-x: hidden;
}

.router-view {
  margin: 0 auto;
  max-width: 1000px !important;
  background-color: #fcfcfc;
  height: 100%;
}

.ls-tabbar {
  z-index: 999;
}

.ls-root-wrapper {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// app/App.vue